import { supabase } from "../supabase/SupabaseClient";
import { FLOTABOT } from "../components/layout/secciones";

/* Entrar una sola vez.
 *
 * El panel de FlotaBot tiene su propia sesión, así que hasta ahora pedía
 * iniciar sesión OTRA VEZ adentro del iframe. Acá se le pasa el token que
 * Supabase ya nos dio al entrar al hub; FlotaBot lo valida contra Supabase y
 * abre su sesión.
 *
 * DOS DETALLES QUE PARECEN DE FORMA Y NO LO SON:
 *
 *   · El token va en el encabezado Authorization y NO en la URL. Lo que va en
 *     la URL queda escrito en los registros del servidor, en el historial del
 *     navegador y en el Referer de todo lo que la página pida después.
 *
 *   · credentials: "include" es lo que hace que el navegador acepte la cookie
 *     que devuelve FlotaBot. Sin eso el pedido sale, contesta 200, y no pasa
 *     absolutamente nada — el síntoma más confuso posible.
 */

let enCurso = null;

export async function abrirSesionEnFlotaBot() {
  // Si dos secciones se abren juntas, que no se pisen: comparten el mismo
  // intento en vez de canjear el token dos veces.
  if (enCurso) return enCurso;

  enCurso = (async () => {
    try {
      const { data } = await supabase.auth.getSession();
      const token = data?.session?.access_token;
      if (!token) return { ok: false, motivo: "sin-sesion" };

      const r = await fetch(`${FLOTABOT}/sso`, {
        method: "POST",
        credentials: "include",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!r.ok) return { ok: false, motivo: `http-${r.status}` };
      return { ok: true };
    } catch (e) {
      // Falla de red, CORS mal configurado, o el panel caído. Para quien llama
      // son lo mismo: hay que mostrar el login de FlotaBot como respaldo.
      console.warn("[sso] no se pudo abrir sesión en FlotaBot:", e);
      return { ok: false, motivo: "red" };
    } finally {
      enCurso = null;
    }
  })();

  return enCurso;
}
